<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 26 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M18.4688 2.34375C18.9002 2.34375 19.25 2.69353 19.25 3.125V4.6875H20.0312C21.7571 4.6875 23.1562 6.08661 23.1562 7.8125V19.5312C23.1562 21.2571 21.7571 22.6562 20.0312 22.6562H5.96875C4.24286 22.6562 2.84375 21.2571 2.84375 19.5312V7.8125C2.84375 6.08661 4.24286 4.6875 5.96875 4.6875H6.75V3.125C6.75 2.69353 7.09978 2.34375 7.53125 2.34375C7.96272 2.34375 8.3125 2.69353 8.3125 3.125V4.6875H17.6875V3.125C17.6875 2.69353 18.0373 2.34375 18.4688 2.34375ZM5.96875 10.1562C5.10581 10.1562 4.40625 10.8558 4.40625 11.7188V19.5312C4.40625 20.3942 5.10581 21.0938 5.96875 21.0938H20.0312C20.8942 21.0938 21.5938 20.3942 21.5938 19.5312V11.7188C21.5938 10.8558 20.8942 10.1562 20.0312 10.1562H5.96875ZM12.793 11.9551C12.8684 11.7941 13.1316 11.7941 13.207 11.9551L14.2178 14.1104L16.4717 14.4551C16.656 14.4834 16.7304 14.7088 16.6006 14.8418L14.9629 16.5225L15.3506 18.8994C15.3815 19.0898 15.1785 19.2283 15.0137 19.1367L13 18.0225L10.9863 19.1367C10.8201 19.2289 10.619 19.0878 10.6494 18.8994L11.0371 16.5225L9.39941 14.8418C9.26964 14.7088 9.34337 14.4827 9.52832 14.4541L11.7822 14.1094L12.793 11.9551ZM5.96875 6.25C5.10581 6.25 4.40625 6.94956 4.40625 7.8125V9.01465C4.86617 8.74832 5.39904 8.59375 5.96875 8.59375H20.0312C20.601 8.59375 21.1338 8.74832 21.5938 9.01465V7.8125C21.5938 6.94956 20.8942 6.25 20.0312 6.25H5.96875Z"
				:fill="color"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgCalendarStar',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
